import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ListSubcategory } from '../used-equipments/models/subcategoryList.model';
import { UsedEquipmentDetail, RandomEquipment } from '../used-equipments/models/detail.model';
import { EquipmentListSubcategory } from '../used-equipments/models/equipmentList.model';

@Injectable({
  providedIn: 'root',
})
export class UsedEquipmentService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiURL;
  private readonly defaultParams = new HttpParams();

  getUsedEquipmentDetail(slug: string): Observable<UsedEquipmentDetail> {
    return this.http.get<UsedEquipmentDetail>(`${this.baseUrl}used-equipment/${slug}/`, {
      params: this.defaultParams,
    });
  }

  getUsedEquipmentSubCategoryBySlug(slug: string): Observable<ListSubcategory> {
    return this.http.get<ListSubcategory>(`${this.baseUrl}used-sub-category-by-slug/${slug}`, {
      params: this.defaultParams,
    });
  }

  getUsedEquipmentRandom(limit = 4): Observable<RandomEquipment> {
    return this.http.get<RandomEquipment>(`${this.baseUrl}used-equipment-random/`, {
      params: this.defaultParams.set('limit', limit),
    });
  }

  getUsedEquipmentsHome(): Observable<EquipmentListSubcategory[]> {
    return this.http.get<EquipmentListSubcategory[]>(`${this.baseUrl}used-equipment/`, {
      params: this.defaultParams.set('show_in_home', true),
    });
  }

  getEquipmentCCU(): Observable<EquipmentListSubcategory[]> {
    return this.http.get<EquipmentListSubcategory[]>(`${this.baseUrl}used-equipment/`, {
      params: this.defaultParams.set('show_in_home', true).set('is_ccu', true),
    });
  }
}
